import { render } from "./BannerPopupSection.vue?vue&type=template&id=2d2d9436&scoped=true"
import script from "./BannerPopupSection.vue?vue&type=script&lang=js"
export * from "./BannerPopupSection.vue?vue&type=script&lang=js"

import "./BannerPopupSection.vue?vue&type=style&index=0&id=2d2d9436&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2d9436"]])

export default __exports__